import { AfterViewInit, Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, EventEmitter, ViewChild, ViewContainerRef } from "@angular/core";
import { AppService } from "@api";
import { FiltroModel } from "@componentes/Filtros/Filtro.model";
import { FiltrosComponent } from "@componentes/Filtros/Filtros.component";
import { TipoFiltroEnum } from "@componentes/Filtros/Filtros.enum";
import { RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";
import { ConsultaAcuerdoDetalleComponent } from "./consultaacuerdodetalle.component";
import { AlertaEnum } from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";


@Component(
    {
        selector: 'consultaacuerdo',
        templateUrl: './consultaacuerdo.component.html',
        styleUrls: ['./consultaacuerdo.component.scss']
    })

export class ConsultaAcuerdoComponent implements AfterViewInit{
    consulta!:boolean;
    listaacuerdo:any[];
    SelCiclo: any[];
    SelPeriodoevaluacion: any[];
    SelDepartamento: any[];
    SelPuesto: any[];
    listageneral: any[] = [];
    tipo:number = 0;

    listaopciones: any[] = [];

    @ViewChild(FiltrosComponent) filtrosComponent!: FiltrosComponent;
    filtrosDisplay: Array<FiltroModel> = [];
    uriApi: string
    @ViewChild("detalleacuerdo", {read: ViewContainerRef}) detalleacuerdo!: ViewContainerRef;
    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){
        this.uriApi = "acuerdo/buscaracuerdo";
        this.listaacuerdo = [];
        this.SelCiclo = [];
        this.SelPeriodoevaluacion = [];
        this.SelDepartamento = [];
        this.SelPuesto = [];
        this.GenerarFiltros();
    }

    ngAfterViewInit(){
        this.LoadDatos().then((respuesta : any)=>{
            this.filtrosComponent.SetFiltros(this.filtrosDisplay, true);
       })
       this.listaopciones = [
        {
          "id": 1,
          "nombre":"Ver a mis colaboradores"
        },
        {
          "id": 2,
          "nombre":"Ver mis acuerdos"
        }
       ]
    }

    //Genera el filtro para las preguntas
    GenerarFiltros() {
        let filtrosDisplay: Array<FiltroModel> = [];
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Ciclo',
                    DisplayValor: 'nombre',
                    ValorName: 'cicloid',
                    Opciones: this.SelCiclo,
                    Propiedad: "cicloid",
                    Obligatorio: false,
                    Buscar: false,
                    Suscripcion: new EventEmitter()
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Periodo evaluacion',
                    DisplayValor: 'descripcion',
                    ValorName: 'periodoevaluacionid',
                    Opciones: this.SelPeriodoevaluacion,
                    Propiedad: "periodoevaluacionid",
                    Obligatorio: false,
                    Buscar: true
                })
        );
        filtrosDisplay.push(
          new FiltroModel(
              {
                  TipoFiltro: TipoFiltroEnum.DropDown,
                  Titulo: 'Departamento',
                  DisplayValor: 'nombre',
                  ValorName: 'departamentoid',
                  Opciones: this.SelDepartamento,
                  Propiedad: "departamentoid",
                  Obligatorio: false,
                  Buscar: true
              })
      );
        this.filtrosDisplay = filtrosDisplay;
    }

    async LoadDatos(){
        return new Promise((resolve) =>{
            Promise.all([
            this.SelFiltroCiclo(),
            this.SelFiltroDepartamento(),
            this.SelFiltroPeriodoevaluacion()
          ]).then((responses : any) =>{
            return resolve(responses);
          });
        });
      }

    SelFiltroCiclo(){
        return new Promise ((resolve) =>{
            this.appService.Get("catalogo/ciclo").then(res=>{
                if(res.status == RespuestaEstatusEnum.Success)
                {
                    this.SelCiclo = res.data;
                    let filtro = this.filtrosDisplay.find(x => x.ValorName == 'cicloid');
                    if (filtro){
                        filtro.Opciones = this.SelCiclo;
                        return resolve(true);
                    }
                    else{
                        return resolve(false);
                    }
                }
                else{
                    return resolve(false);
                }
            })
        });
    }

    SelFiltroPeriodoevaluacion(){
        return new Promise ((resolve) =>{
          this.appService.Post("planeacion/periodoevaluacion/buscar",{}).then(res=>{
              if(res.status == RespuestaEstatusEnum.Success) {
                  this.SelPeriodoevaluacion = res.data;
                  let filtro = this.filtrosDisplay.find(x => x.ValorName == 'periodoevaluacionid');
                  if(filtro){
                    filtro.Opciones = this.SelPeriodoevaluacion;
                    filtro.Valor = this.SelPeriodoevaluacion[0].periodoevaluacionid;
                  }
                  return resolve(true);
              }
              else{
                  return resolve(false);
              }
          });
        });
    }

    SelFiltroDepartamento(){
      return new Promise ((resolve) =>{
        if(this.sistemaService.permisos.edicionespecial){
          this.appService.Get("configuracionrh/departamento/usuario").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelDepartamento = res.data;
                let filtro = this.filtrosDisplay.find(x => x.ValorName == 'departamentoid');
                if (filtro){
                    filtro.Opciones = this.SelDepartamento;
                }
                return resolve(true);
            }else{
                return resolve(false);
            }
        });
        }else{
          this.appService.Post("configuracionrh/departamento/buscar", {activo: 1}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelDepartamento = res.data;
                let filtro = this.filtrosDisplay.find(x => x.ValorName == 'departamentoid');
                if (filtro){
                    filtro.Opciones = this.SelDepartamento;
                }
                return resolve(true);
            }else{
                return resolve(false);
            }
        });
        }
    });
    }

    SetDatos(data:any){
        this.listaacuerdo = data;
        this.listageneral = data;
        this.tipo = 0;
    }

    filtrardatos(e:any){
      if(e){
        if(this.listageneral.length == 0){
          this.mensajeService.Alerta(AlertaEnum.Warning, "No se tienen datos para ser filtrados")
        }else{
          switch(e){
            case 1:
              this.listaacuerdo = this.listageneral.filter(x=> x.esjefe == true);
              break;
              case 2:
                this.listaacuerdo = this.listageneral.filter(x=> x.esjefe == false);
              break;
          }
        }

      }else{
        this.listaacuerdo = this.listageneral;
      }
    }

    onRowPrepared(e:any){
      if(e.rowType == "data"){
        if(e.key.firmado){
          e.rowElement.bgColor = "#E4F1EE";
        }
      }
  }

    Formulario(accionid:number, entidad:any){
      let accion = "";
      switch (accionid) {
          case 1:
              accion = "Editar";
              break;
          case 2:
            accion = "Ver"
            break;
      }
      this.cargarContenedorFormulario({accion: accion, entidad: entidad, identificador: accionid});
    }

    cargarContenedorFormulario(data: {accion: string, entidad: any, identificador: number}) {
      this.consulta = true;
      this.detalleacuerdo.clear();
      const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(ConsultaAcuerdoDetalleComponent);
      var ref: ComponentRef<any> = this.detalleacuerdo.createComponent(factory);
      ref.instance.entidad = data.entidad;
      ref.instance.accion = {accionid: data.identificador, accion: data.accion};
      ref.instance.output.subscribe((cambio: boolean) => {
          this.consulta = false;
          ref.destroy();
          if(cambio){
            this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
          }
      });
    }
}
